export default __webpack_public_path__ + "static/773-482244e7f002132d33a91d32b8b7ec7d.gif";